import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { useState } from 'react';

interface TraceReasoningRowProps {
  text: string;
}

export default function TraceReasoningRow({ text }: TraceReasoningRowProps) {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box sx={{ minWidth: 0 }}>
      <ButtonBase
        aria-expanded={isOpen}
        data-test-id="tread-agent-trace-reasoning"
        onClick={() => setIsOpen((wasOpen) => !wasOpen)}
        sx={{
          alignItems: 'center',
          display: 'flex',
          gap: 0.75,
          justifyContent: 'flex-start',
          minWidth: 0,
          textAlign: 'left',
          width: '100%',
        }}
      >
        <Typography
          sx={{
            color: theme.brandV2.colors.treadGray2,
            flexShrink: 0,
            fontSize: '12px',
            fontWeight: 500,
          }}
        >
          {t('tread_agent.trace.thinking')}
        </Typography>

        {!isOpen && (
          <Typography
            sx={{
              backgroundColor: theme.brandV2.colors.treadGray9,
              borderRadius: theme.brandV2.borderRadius,
              color: theme.brandV2.colors.treadGray3,
              fontSize: '12px',
              minWidth: 0,
              overflow: 'hidden',
              px: 0.75,
              py: 0.25,
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {text}
          </Typography>
        )}
      </ButtonBase>

      {isOpen && (
        <Typography
          data-test-id="tread-agent-trace-reasoning-full"
          sx={{
            color: theme.brandV2.colors.treadGray2,
            fontSize: '12px',
            lineHeight: 1.5,
            mt: 0.5,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {text}
        </Typography>
      )}
    </Box>
  );
}
